package com.bikompanion.ui.home

import androidx.navigation3.runtime.NavEntry
import androidx.navigation3.scene.Scene
import androidx.navigation3.scene.SceneStrategy
import androidx.navigation3.scene.SceneStrategyScope

/** Folds every back stack the home screen can have into the one [HomeScene]. */
internal class HomeSceneStrategy : SceneStrategy<HomeRoute> {
    override fun SceneStrategyScope<HomeRoute>.calculateScene(entries: List<NavEntry<HomeRoute>>): Scene<HomeRoute>? {
        // The map is always the first entry, so there is nothing else to tell apart.
        if (entries.isEmpty()) return null
        return HomeScene(entries = entries, previousEntries = entries.dropLast(1))
    }
}
